import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import { Uploader } from '__generated__/Uploader';
import AttachmentUploader from 'common/components/uploader/AttachmentUploader';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    inspirationFiles: StructuredBriefFile[];
}

interface Props<T> {
    form: ObservableForm<T>;
    uploader: Uploader;
}

const InspirationFilesField: <T extends Fields>(
    props: Props<T>
) => React.ReactElement<Props<T>> = ({ form, uploader }) => {
    return (
        <Field
            form={form}
            name="inspirationFiles"
            title={__('Add inspiration files')}
            message={__(
                "Upload any designs or imagery you like so your designer gets an idea of the style you're looking for."
            )}
            render={() => (
                <AttachmentUploader uploader={uploader} {...form.attach('inspirationFiles')} />
            )}
        />
    );
};

export default InspirationFilesField;
